import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

export interface TenantFeatures {
  write_tools?: boolean
  smart_import?: boolean
  transit_matrix?: boolean
  suggestions_synthesized?: boolean
  dashboard_pg?: boolean
}

export interface OperatorConfig {
  name: string
  short: string
  company: string
  ownerName: string
  logoUrl: string
  colorPrimary: string
  colorAccent: string
  tenantId: string
  features: TenantFeatures
}

const DEFAULTS: OperatorConfig = {
  name: 'Magic Metrics',
  short: 'Magic Metrics',
  company: 'MagicMoney',
  ownerName: 'Brian',
  logoUrl: '/butler/butler-logo.png',
  colorPrimary: '#3b82f6',
  colorAccent: '#06b6d4',
  tenantId: 'butler',
  features: {},
}

const OperatorContext = createContext<OperatorConfig>(DEFAULTS)

export function useOperator() {
  return useContext(OperatorContext)
}

export function OperatorProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<OperatorConfig>(DEFAULTS)

  useEffect(() => {
    let cancelled = false
    fetch('/api/config/operator')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data) {
          const merged = { ...DEFAULTS, ...data }
          setConfig(merged)
          document.title = `${merged.short} — ${merged.company}`
          if (merged.tenantId && merged.tenantId !== 'butler') {
            document.documentElement.setAttribute('data-tenant', merged.tenantId)
          }
        }
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  return (
    <OperatorContext.Provider value={config}>
      {children}
    </OperatorContext.Provider>
  )
}
